import React, { useState } from 'react';
import { X, Music2, Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../utils/api';

const SuggestionForm = ({ guestId, eventId, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    requested_title: '',
    requested_artist: '',
    link: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.requested_title.trim()) {
      toast.error('Veuillez entrer le titre de la piste');
      return;
    }

    setSubmitting(true);
    try {
      await api.post(`/guests/${guestId}/suggestions`, {
        guest_id: guestId,
        event_id: eventId,
        requested_title: formData.requested_title.trim(),
        requested_artist: formData.requested_artist.trim() || null,
        link: formData.link.trim() || null
      });

      // Update local suggestions count
      const session = JSON.parse(localStorage.getItem('guestSession') || '{}');
      session.suggestionsCount = (session.suggestionsCount || 0) + 1;
      localStorage.setItem('guestSession', JSON.stringify(session));

      onSuccess();
    } catch (error) {
      console.error('Error creating suggestion:', error);
      const errorMsg = error.response?.data?.detail || 'Erreur lors de l\'envoi de la suggestion';
      toast.error(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50" onClick={onClose}>
      <div 
        className="bg-slate-800 rounded-2xl border border-slate-700/50 max-w-lg w-full shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-700/50">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-br from-orange-500 to-coral-500 rounded-lg">
              <Music2 className="w-5 h-5 text-white" />
            </div>
            <h3 className="text-xl font-bold text-white">Suggérer une piste</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-2">
              Titre de la piste <span className="text-orange-500">*</span>
            </label>
            <input
              type="text"
              value={formData.requested_title}
              onChange={(e) => setFormData({ ...formData, requested_title: e.target.value })}
              placeholder="Ex: Starboy"
              className="w-full px-4 py-3 bg-slate-900/50 border border-slate-700 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
              maxLength={100}
              disabled={submitting}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-300 mb-2">
              Artiste
            </label>
            <input
              type="text"
              value={formData.requested_artist}
              onChange={(e) => setFormData({ ...formData, requested_artist: e.target.value })}
              placeholder="Ex: The Weeknd"
              className="w-full px-4 py-3 bg-slate-900/50 border border-slate-700 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
              maxLength={100}
              disabled={submitting}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-300 mb-2">
              Lien Spotify (optionnel)
            </label>
            <input
              type="url"
              value={formData.link}
              onChange={(e) => setFormData({ ...formData, link: e.target.value })}
              placeholder="https://open.spotify.com/track/..."
              className="w-full px-4 py-3 bg-slate-900/50 border border-slate-700 rounded-xl text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
              disabled={submitting}
            />
          </div>

          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-3 bg-slate-700 text-white font-medium rounded-xl hover:bg-slate-600 transition"
              disabled={submitting}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={submitting || !formData.requested_title.trim()}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-orange-500 to-coral-500 text-white font-semibold rounded-xl hover:from-orange-600 hover:to-coral-600 disabled:opacity-50 disabled:cursor-not-allowed transition shadow-lg"
            >
              <Send className="w-4 h-4" />
              <span>{submitting ? 'Envoi...' : 'Envoyer'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuggestionForm;
